import { FEATURES_ID, PERMISSIONS } from 'common/constants'
import getObject from 'common/helpers/recursive-helper'
import { navItems, SideNavItem } from 'components/organisms/MainMenu/settings'

export const findNavItemByPath = (path: string): SideNavItem | null => {
  if (!path) return null

  const selectedKey = path.replace('/', '').split('/').splice(0, 2).join('.')
  let selectedNavItem = getObject(navItems, 'key', selectedKey) as SideNavItem

  if (!selectedNavItem) {
    selectedNavItem = getObject(navItems, 'key', selectedKey.split('.')[0]) as SideNavItem
  }

  return selectedNavItem
}

export const hasSpecialFeaturePermission = (featureId: string | number, userPermissions: any): boolean => {
  return (
    [FEATURES_ID.SETTING_ONBOARDING, FEATURES_ID.SETTING_SERVICE_LINKAGE, FEATURES_ID.AI_AGENT].includes(
      Number(featureId) as any
    ) && userPermissions[featureId] > 0
  )
}

export const isPermissionDenied = (featureId: string | number, userPermissions: any): boolean => {
  return (
    featureId !== FEATURES_ID.SETTING_RECALCULATE &&
    (userPermissions[featureId] === 0 || userPermissions[featureId] === PERMISSIONS.EXECUTE)
  )
}

export const getRouteBasedPermission = (path: string, permission: any): boolean => {
  if (path.match(/new/g) || path.match(/copy/g)) return permission.isCreate
  if (path.match(/edit/g)) return permission.isEdit
  return true
}
